import { Select } from "antd";
import { FC } from "react";

const SelectProductTypeField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="page" >صفحه</Select.Option>
      <Select.Option key="post" >پست</Select.Option>
    </Select>
  )
}

export default SelectProductTypeField
